import { useState } from 'react';
import { AUTH_USER_ID } from '@prosaas/psw-events';
import type { UUID } from '../utils/interfaces';
import { useSubscriptions } from '@prosaas/psw-utils';

export const useUserId = (): UUID | undefined => {
  const [userId, setUserId] = useState<UUID | undefined>();

  useSubscriptions([
    [
      AUTH_USER_ID,
      (id: UUID | null) => {
        setUserId(id ?? undefined);
      },
    ],
  ]);

  return userId;
};
